 import { Json } from "../interfaces/layouts"
import __cases from './__cases'
import arrayGroupBy from "./arrayGroupBy"
import clearHTML from "./clearHTML"
import { getContrastColor, getDarker, getRandomColor, parseGradient } from "./colors"
import compareArrays, {separateArrays} from './compareArrays'
import { comparePeriods } from "./comparePeriods"
import { intToTime } from "./date"
import { getInnerHeight, getWindowWidthFromElementWidth } from './document'
import { initArea } from './getWidget'
import getWidgets from './getWidgets'
import { __, getAllDictionaries, initDictionary } from "./i18n"
import imgToDataURL from "./imgToDataURL"
import importAll, { getAllViews, getAllWidgets, getModules } from './importAll'
import isArraysJoint from "./isArraysJoint"
import isEmail from './isEmail'
import isImageExt from './isImageExt'
import { data_type_admin_url, data_type_feed_url, data_type_link_url } from "./links"
import { shuffle } from "./shuffle"
import { trimContent, trimLettersContent } from "./trimContent"
import {
    extractVimeoVideoID,
    getVimeoThumbnail,
    getYoutubeData,
    sprintf,
    timeToReadableString
} from "./sprintf"
import translitterate from "./translitterate"
import { isCapability } from "./user"
import Widgets from "./Widgets"
import { withRouter } from './withRouter'
import { wordTrim, letterTrim } from "./wordTrim"
import { getCssDemention, getCSSPartDemention, getSCSSDifference, getDementionData } from "./getCssDemention"
import getPlural from "./getPlural"
import getID from "./getID"
import {camelToKebabCase, CSSObjectToString} from "./css"
import { cacheJsonToWP, clearJsonFromWP } from "./wp/json"
import { getColumnClassName } from "./layout"

export {
    __, __cases, arrayGroupBy, clearHTML, compareArrays, comparePeriods, data_type_admin_url, data_type_feed_url, data_type_link_url, extractVimeoVideoID, getAllDictionaries, getAllViews,
    getAllWidgets, getContrastColor, getDarker, getRandomColor, parseGradient, getInnerHeight, getModules, getVimeoThumbnail, getWidgets, getYoutubeData, imgToDataURL, importAll, initArea, initDictionary, intToTime, isArraysJoint, isCapability, isEmail, isImageExt, shuffle, sprintf, timeToReadableString, translitterate, Widgets,
    withRouter, wordTrim, letterTrim, getCssDemention, getCSSPartDemention, getSCSSDifference, trimContent, trimLettersContent, getPlural, getID, getDementionData, camelToKebabCase, CSSObjectToString,
    getWindowWidthFromElementWidth, separateArrays, cacheJsonToWP, clearJsonFromWP, getColumnClassName
}
export const jsonToData = (json: Json, callback?: () => void, errorCallback?: () => void ) : any => {
    try {
        const data: any = JSON.parse(json) 
        if( !!callback) {
            callback()
        }
        return data
    }
    catch(e: any) {
        console.log( json )
        console.log( e )
        if( !!errorCallback) {
            errorCallback()
        }
        return ""
    }
}

export const setMaxHeightByClass = ( className: string ) => {
    const max: number  = Math.max(...[...Array.from( document.getElementsByClassName( className ) ) ]
        .map( (div: any) => div.clientHeight as number ) ) 
    Array.from( document.getElementsByClassName( className ) )
        .forEach((div: any) => {
            div.style.height = `${max}px`
        })
}
 
export const setMaxHeightByQuery = ( query: string ) => {
    const max: number  = Math.max(
        ...[...Array.from( document.querySelectorAll( query ) ) ]
        .map((div: any) => { 
            div.style.height = "auto"
            return div.scrollHeight as number
        })
    )
    Array.from( document.querySelectorAll( query ) )
        .forEach((div: any) => {
            div.style.height = `${max}px`
        })
}
export function setAutoHeightByClass(className: string) {
    Array.from( document.getElementsByClassName( className ) )
        .forEach((div: any) => {
            div.style.height = null
        })
} 
export function setAutoHeightByQuery(query: string) {
    Array.from( document.querySelectorAll( query ) )
        .forEach((div: any) => {
            div.style.height = null
        })
}

export const getLayoutApp = (): HTMLElement => {
    const div: HTMLElement = document.getElementById("pe-layout-main")!
    return div
}

export function getDomainName(url: string) {
  try {
    const urlObject = new URL(url);
    return urlObject.hostname;
  } catch (error) {
    console.error("Invalid URL:", error);
    return null;
  }
}
